import { AUDIT_LOGS_TAB } from 'common/constants/user';
import {
  ACCOUNT_SETTINGS_SLUG,
  ASSIGNMENT_RULES_SLUG,
  COMPANIES_SLUG,
  CURRENT_VALUATIONS_SLUG,
  DASHBOARD_SLUG,
  INFORMATION_SLUG,
  OPPORTUNITIES_SLUG,
  OVERVIEW_SLUG,
  PAST_VALUATIONS_SLUG,
  SETTINGS_SLUG,
  SUBSCRIPTION_SLUG,
  WORKBOARD_SLUG,
} from 'dashboard409a/common/constants/urls';

export const DASHBOARD_COMPANY_SLUG = `/${DASHBOARD_SLUG}/${COMPANIES_SLUG}/:companySlug`;
export const DASHBOARD_COMPANY_OVERVIEW_SLUG = `${DASHBOARD_COMPANY_SLUG}/${OVERVIEW_SLUG}`;
export const DASHBOARD_COMPANY_SETTINGS = `${DASHBOARD_COMPANY_SLUG}/${SETTINGS_SLUG}`;
export const DASHBOARD_COMPANY_SUBSCRIPTION = `${DASHBOARD_COMPANY_SLUG}/${SUBSCRIPTION_SLUG}`;
export const DASHBOARD_COMPANY_INFORMATION = `${DASHBOARD_COMPANY_SLUG}/${INFORMATION_SLUG}`;

export const DASHBOARD_WORKBOARD_SLUG = `/${WORKBOARD_SLUG}`;

export const IS_WORKBOARD = [
  CURRENT_VALUATIONS_SLUG,
  PAST_VALUATIONS_SLUG,
  OPPORTUNITIES_SLUG,
  ACCOUNT_SETTINGS_SLUG,
  AUDIT_LOGS_TAB,
  ASSIGNMENT_RULES_SLUG,
];
export const IS_REPORTS_PAGE = [COMPANIES_SLUG, `/${DASHBOARD_SLUG}/${COMPANIES_SLUG}/`];
